import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router';
import useSWR from 'swr';
import { SearchCriteria } from '@/Models/SearchCriteria';
import http from '@/Utils/HTTP/NewHttpUtils';
import ResourceNotFoundError from '@/Utils/HTTP/Errors/ResourceNotFoundError';
import GuidHelper from '@/Utils/GuidHelper';

interface SearchCriterionResponse {
    id: string;
    criterion: string;
}

export interface SearchCriteriaResponse {
    criteria: SearchCriterionResponse[];
}

const DefaultSearchCriteriaResponse: SearchCriteriaResponse = {
    criteria: Array.from({ length: 5 }, () => {
        return {
            id: GuidHelper.Empty,
            criterion: '',
        };
    }),
};

export interface SearchCriteriaFilters {
    rankingCriteria: SearchCriteria[];
}

export const convertSearchCriteriaResponseToSearchCriteriaFilters = (
    searchFiltersData: SearchCriteriaResponse,
): SearchCriteriaFilters => {
    return {
        rankingCriteria: searchFiltersData.criteria.map((x) => ({
            id: x.id,
            criterion: x.criterion,
        })),
    };
};

export const useSearchCriteria = (recruitmentIdParam?: string) => {
    const { assessmentId: recruitmentIdUrl } = useParams();
    const recruitmentId = recruitmentIdParam || recruitmentIdUrl;
    const { getAccessTokenSilently } = useAuth0();

    return useSWR(`recruitments/${recruitmentId}/ai-search/search-criteria`, async (url) => {
        try {
            const response = await http.get<SearchCriteriaResponse>({
                path: url,
                accessToken: await getAccessTokenSilently(),
            });

            // if the flow is updated and search criteria can be empty
            // you are right to be looking into this and find the empty
            // array returned by the backend is not reflected in the table
            // because we replaced it with 5 empty criteria response
            return response || DefaultSearchCriteriaResponse;
        } catch (error) {
            if (error instanceof ResourceNotFoundError) {
                return DefaultSearchCriteriaResponse;
            }

            throw error;
        }
    });
};
